import React, { useState, ChangeEvent, FormEvent } from 'react';
import '../styling/Contact.css';

interface FormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}

const Contact: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    
    const message = `Hello! I'm contacting you through travelisk.in.

*Contact Details:*
Name: ${formData.firstName} ${formData.lastName}
Email: ${formData.email}
Phone: ${formData.phone}

*Subject:* ${formData.subject}

*Message:*
${formData.message}

Thank you!`;

    const encodedMessage = encodeURIComponent(message);
    
    window.open(`https://wa.me/7980013170?text=${encodedMessage}`, '_blank');
    
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div>
      <div className="contact-header">
        <div className="container">
          <h1 className="contact-title">Contact Us</h1>
          <p className="contact-subtitle">
            Get in touch with us for any questions about our travel packages
          </p>
        </div>
      </div>

      <div className="container">
        <div className="contact-container">
          <div className="contact-form">
            <h2 className="form-title">Send us a Message</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    className="form-input"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-field">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-input"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-input"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-field">
                  <label className="form-label">Phone</label>
                  <input
                    type="tel"
                    className="form-input"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              
              <div className="form-field">
                <label className="form-label">Subject</label>
                <input
                  type="text"
                  className="form-input"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form-field">
                <label className="form-label">Message</label>
                <textarea
                  className="form-textarea"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <button type="submit" className="submit-button">
                Send Message
              </button>
            </form>
          </div>

          <div className="contact-info">
            <h2 className="info-title">Contact Information</h2>
            
            <div className="info-item">
              <div className="info-icon">📍</div>
              <div className="info-content">
                <h4>Address</h4>
                <p>2/119B, Vidyasagar Colony, Ganguly Bagan, Kolkata, West Bengal 700047</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">📞</div>
              <div className="info-content">
                <h4>Phone</h4>
                <p>+91 7002155057</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">✉️</div>
              <div className="info-content">
                <h4>Email</h4>
                <p>traveliskinfo@gmail.com</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">🕒</div>
              <div className="info-content">
                <h4>Working Hours</h4>
                <p>Monday - Friday: 10:00 AM - 8:00 PM</p>
                <p>Saturday: 10:00 AM - 8:00 PM</p>
                <p>Sunday: Closed</p>
              </div>
            </div>
          </div>
        </div>

        <div className="map-container">
          <iframe
            className="map-iframe"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3648.2228517396748!2d88.37059117525281!3d22.480714679557288!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0271101d3dc4c3%3A0x9607f01b5c0b26e2!2s2%2F119B%2C%20Vidyasagar%20Colony%2C%20Ganguly%20Bagan%2C%20Kolkata%2C%20West%20Bengal%20700047!5e1!3m2!1sen!2sin!4v1753888136720!5m2!1sen!2sin"
            title="Our Location"
            allowFullScreen={true}
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default Contact; 